import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ActionButtonComponent } from "@components/action-button/action-button.component";
import { ButtonComponent } from "@components/button/button.component";
import { LabelComponent } from "@components/label/label.component";
import { PageComponent } from "@components/page/page.component";
import { SaveButtonComponent } from "@components/save-button/save-button.component";
import { ToggleListItemComponent } from "@components/toggle-list/toggle-list-item/toggle-list-item.component";
import { ToggleListComponent } from "@components/toggle-list/toggle-list.component";
import { TranslatePipe } from "@ngx-translate/core";
import { KundorderTyp } from "~app/common/models/constants";
import { OrderDetailsComponent } from "../../order/order-details/order-details";
import { OrderHeaderComponent } from "../../order/order-details/order-header/order-header.component";
import { KundorderradDetailsComponent } from "./kundorderrad-details/kundorderrad-details.component";
import { KundorderradEditComponent } from "./kundorderrad-edit/kundorderrad-edit.component";
@Component({
    selector: "rask-kundorder-details",
    templateUrl: "./kundorder-details.component.html",
    styleUrls: ["./kundorder-details.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        PageComponent,
        ActionButtonComponent,
        OrderHeaderComponent,
        ToggleListComponent,
        LabelComponent,
        ToggleListItemComponent,
        KundorderradEditComponent,
        KundorderradDetailsComponent,
        ButtonComponent,
        SaveButtonComponent,
        TranslatePipe
    ]
})

export class KundorderDetailsComponent extends OrderDetailsComponent {
    kundorderTyp = KundorderTyp.Kundorder;

    copy = () => {
        this.router.navigate(["copy"], { relativeTo: this.activatedRoute.parent });
    };
}
